module.exports = __webpack_public_path__ + "img/share.cb42b810.svg";